import { render } from "./Hmenu.vue?vue&type=template&id=54434215&scoped=true"
import script from "./Hmenu.vue?vue&type=script&lang=js"
export * from "./Hmenu.vue?vue&type=script&lang=js"

import "./Hmenu.vue?vue&type=style&index=0&id=54434215&scoped=true&lang=css"

import exportComponent from "C:\\TK\\LivppyLab\\LivppyLab\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-54434215"]])

export default __exports__